<template>
    <div class="container">
        <div v-if="stepData.length > 2">
            <el-steps :active="activeStep" finish-status="finish"   align-center>
                <el-step  description="" v-for="(item,index) in stepData" :key="index" :title="item.title">
                    <template slot ="description">
                        <div style="width: 154px;">{{item.description}}</div>
                        <div>{{item.handlePeo}}  {{item.creatTime}}</div>
                    </template>
                </el-step>
            </el-steps>
        </div>
        <div v-else>
            <el-steps :active="2" finish-status="finish" align-center>
                <el-step :title="stepData[0].title">
                    <template slot ="description">
                        <div >{{stepData[0].description}}</div>
                        <div>{{stepData[0].handlePeo}}  {{stepData[0].creatTime}}</div>
                    </template>
                </el-step>
                <el-step :title="stepData[1].title" status="error">
                    <template slot ="description">
                        <div >{{stepData[1].description}}</div>
                        <div>{{stepData[1].handlePeo}}  {{stepData[1].creatTime}}</div>
                    </template>
                </el-step>
            </el-steps>
        </div>

    </div>
</template>
<script>
    export default {
        name: "steps",
        props:{
            stepData:{
                type:Array,
                required:true
            },
            activeStep:{
                type:Number,
                default:1,
                required:false
            },
        },
    }
</script>

<style scoped lang="scss">

</style>